interface ErrorWithDetails {
	status?: number;
	detail?: string;
	message?: string;
}

export const GetErrorMessage = (error: ErrorWithDetails | Error): string => {
	let errorMessage;
	const status = (error as ErrorWithDetails).status;
	if (status && status === 400) {
		errorMessage = "An error occurred. Please try refreshing the page.";
	} else if (status && status === 500) {
		errorMessage = "An error occurred. Please try again later.";
	} else if (status && [503, 504].includes(status)) {
		errorMessage = `We had an error contacting the API. An ${status} occurred`;
	} else if (error.toString() === "TypeError: Failed to fetch") {
		errorMessage = "An error occurred while trying to reach the API. Please try again later.";
	} else {
		errorMessage = (error as ErrorWithDetails)?.detail || error?.message || "Something went wrong";
	}
	return errorMessage;
};
